import Input from '@/components/Input/Input';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';
import { UpChargePriceProps } from '../EditBundle.types';

export const UpChargePrice = (upChargePriceProps: UpChargePriceProps) => {
  const { onChange, upChargePrice } = upChargePriceProps;

  return (
    <div>
      <Typography
        sx={{
          fontFamily: 'Open Sans',
          paddingTop: 2,
          paddingBottom: 2,
          fontSize: ' 1.8rem',
        }}
      >
        <InfoOutlined fontSize="large" style={{ color: '#266DCC' }} /> &nbsp; This amount will be added to the base
        price of this bundle only
      </Typography>
      <Box sx={{ width: '30%' }}>
        <Input
          id="upChargePrice"
          type="number"
          label="Enter upcharge for this bundle"
          placeholder=""
          pattern="[0-9]*"
          onChange={(event) => {
            onChange(event.target.value);
          }}
          value={String(upChargePrice)}
        />
      </Box>
    </div>
  );
};
